import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getActiveRide = async (callerId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      callerId,
    },
    query: graphql(`
      query GetActiveRide($callerId: String!) {
        getActiveRide(callerId: $callerId) {
          requestId
          gogoMap
          startLat
          startLong
          destinationLat
          destinationLng
          endLat
          endLong
          curLat
          curLng
          status
        }
      }
    `),
  });

  return response.data.getActiveRide;
};
